import * as firebase from "firebase";
import "firebase/firestore";

const config = {
  // production
  apiKey: "AIzaSyA7ulBNHNFl1G4XBFDMHm1UZrxrbkjvQOQ",
  authDomain: "ioty-app.firebaseapp.com",
  databaseURL: "https://ioty-app.firebaseio.com",
  projectId: "ioty-app",
  storageBucket: "ioty-app.appspot.com",
  messagingSenderId: "656155882462",
  appId: "1:656155882462:web:50e9048fc7b9ad7716a34f"

  //dev
  // apiKey: "AIzaSyCJqJrzCdNB11bxq8mtWD4zjYE-QnE63qo",
  // authDomain: "signalflow-dev.firebaseapp.com",
  // databaseURL: "https://signalflow-dev-default-rtdb.firebaseio.com",
  // projectId: "signalflow-dev",
  // storageBucket: "signalflow-dev.appspot.com",
  // messagingSenderId: "571729654614",
  // appId: "1:571729654614:web:f5bb58a80924a06797dcf7"
};

export const app = firebase.initializeApp(config);
export const bundles = firebase.firestore().collection("bundles");
export const companies = firebase.firestore().collection("companies");
export const ipackages = firebase.firestore().collection("ipackages");
export const items = firebase.firestore().collection("items");
// export const menuSpots = firebase.database().ref('admin/menuSpots/')
export const hotspotMenu = firebase.database().ref("admin/hotspotMenu/");
export const projects = firebase.firestore().collection("projects");
export const steppers = firebase.firestore().collection("steppers");
export const transactions = firebase.firestore().collection("transactions");
export const categoryWithSubCategory = firebase
  .firestore()
  .collection("categoryWithSubCategory");
export const users = firebase.firestore().collection("users");
export const projectbundles = firebase.firestore().collection("projectbundles");



// WEBPACK FOOTER //
// ./src/db/index.js